






























































import '@/assets/css/components/select-custom.scss'
import { Component, Prop, Watch } from 'vue-property-decorator';
import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import SelectMixin from '@/components/select/SelectMixin';
import { getList } from '@/api/crud';

import { LoadPropType } from './types';

import {
    defaultParamsFormatter,
    defaultLabelFormatter,
} from './utils'

library.add(faTimesCircle);

let timeout: number|undefined;


@Component({
    name: 'SelectCustom',
    model: {
      prop: 'current',
      event: 'click'
    },
    mixins: [SelectMixin],
    components: {
        FontAwesomeIcon,
    },
})
export default class SelectCustom extends SelectMixin {
    @Prop({ type: Boolean, default: false }) isInput!: boolean;
    @Prop({ type: String, default: '' }) inputPlaceholder!: string;
    @Prop({ type: Object, default: null }) load!: LoadPropType|null;
    @Prop({ type: String, default: null }) autocomplete!: string;
    @Prop({ type: Boolean, default: true }) isPadded!: boolean;
    @Prop({ type: Boolean, default: false }) disabled!: boolean;

    get filteredItems () {
        if (this.load) {
            return this.loadedItems;
        }

        return this.items.filter((item) => item.value.toLowerCase().indexOf(this.search.toLowerCase()) !== -1);
    }

    @Watch('visible')
    onVisibleChanged(val: any) {
        if (val) this.loadItems();
    }

    async loadItems () {
        if (!this.load) return;

        const filterName = this.load.filterName || 'title';
        const formatParams = this.load.formatParams || defaultParamsFormatter;
        const formatLabel = this.load.formatLabel || defaultLabelFormatter;
        
        const search = [
            formatParams(this.search, filterName),
            this.load.filterString
        ]
        .filter(value => value)
        .join('&');

        const res = await getList(this.load.entityName, {page: 1}, '', search);

        const rows = Array.isArray(res) ? res : res?.table?.rows || [];
        this.$emit('loaded', rows);
        this.loadedItems = rows.map((item: any) => ({
            id: item.id,
            value: formatLabel(item, filterName),
        }));
    }

    input (e: Event): void {
        this.search = (e.target as HTMLInputElement).value;
        this.val = null;

        if (!this.visible) {
            this.openSelect();
        }

        if (this.load) {
            clearTimeout(timeout);
            timeout = setTimeout(() => {
                this.loadItems();
            }, 200);
        }
    }
}
